import React from 'react';
import { SvgProps } from './icon.types';

export function ChartIcon({ title, width = 24, height = 24, fill = '#2D3049', ...props }: SvgProps) {
  return (
    <svg height={height} width={width} xmlns="http://www.w3.org/2000/svg" {...props}>
      {title && <title>{title}</title>}
      <g fill={fill} fillRule="evenodd">
        <path d="M3 20h18v2H3zM5 11v7H3v-7zM21 8v10h-2V8zM17 10v8h-2v-8zM13 2v16h-2V2zM9 6v12H7V6z" />
      </g>
    </svg>
  );
}
